import React from "react";
import { datadogRum } from "@datadog/browser-rum";

import { getEnvironmentOrDefault } from "../utilities/environment";

const ENVIRONMENT = getEnvironmentOrDefault();
const VERSION = import.meta.env.VITE_APP_VERSION;

// Flag to guarantee DataDog is only intialized once.
// Initializing DataDog multiple times logs an error.
// TODO: figure out why this is necessary. Might be caused by React rendering
// twice in dev mode?
let isInitialized = false;

/**
 * This hook initializes DataDog monitoring.
 * It should be called as early as possible, even before a user has logged in,
 * to ensure all errors are caught. Another hook, useDatadogUser(), should be
 * used after login to inform DataDog of the user's identity.
 */
export default function useDatadogInit() {
  React.useEffect(() => {
    // Do not start Data Dog when running locally.
    if (ENVIRONMENT !== "local-dev") {
      if (isInitialized) {
        return;
      }

      datadogRum.init({
        applicationId: "f923a6e9-7d30-4942-b2b5-58c64cbbe4e4",
        clientToken: "pub4ca1f36a883475eeeef072c1b93eae35",
        site: "datadoghq.com",
        service: "corteva-chat-frontend",
        env: ENVIRONMENT,
        version: VERSION ?? "local-dev",
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask",
        beforeSend: (event: any) => {
          // Remove tokens from requests
          // try/catch because not all events have every property.
          try {
            event.resource.url = event.resource.url.replace(
              /token=[^&]*/g,
              "token=REDACTED"
            );
          } catch (error) {
            // pass
          }
          try {
            event.error.resource.url = event.error.resource.url.replace(
              /token=[^&]*/g,
              "token=REDACTED"
            );
          } catch (error) {
            // pass
          }
          try {
            event.error.message = event.error.message.replace(
              /token=[^&]*/g,
              "token=REDACTED"
            );
          } catch (error) {
            // pass
          }
          try {
            event.error.stack = event.error.stack.replace(
              /token=[^&]*/g,
              "token=REDACTED"
            );
          } catch (error) {
            // pass
          }

          try {
            event.view.url = event.view.url.replace(
              /token=[^&]*/g,
              "token=REDACTED"
            );
          } catch (error) {
            // pass
          }
          return true;
        },
      });

      datadogRum.setGlobalContext({
        env: ENVIRONMENT,
        research: {
          application: "corteva-chat-frontend",
          system: "ai-pioneers",
          domain: "dataengineering",
        },
      });

      datadogRum.startSessionReplayRecording();

      isInitialized = true;
    }
  }, []);
}
